import "../../../styles/forms.scss";
import { useTranslation } from "react-i18next";

export default function OtherLanguageSectionPreview({
  otherLanguage,

  index
}) {
  const { t } = useTranslation();

  return (
    <div className="row skill-language-width">
      <div className="col-4">
        <div className="form-group">
          {index === 0 && (
            <div className="label-wrapper">
              <label>{t("Other language")}</label>
            </div>
          )}
          <select
            className="form-select"
            value={otherLanguage.language || ""}
            name="language"
            disabled
          >
            <option>{otherLanguage.languageDescription}</option>
          </select>
        </div>
      </div>
      <div className="col-4">
        <div className="row">
          <div className="form-group">
            {index === 0 && (
              <div className="label-wrapper">
                <label>{t("Language level")}</label>
              </div>
            )}
            <div className="select-wrapper">
              <select className="form-select" name="languageLevel" disabled>
                <option>{otherLanguage.languageLevelDescritpion}</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
